import { Injectable, signal } from '@angular/core';
import { NotificationCounts } from './notification-facade.service';

@Injectable({
	providedIn: 'root',
})
export class MessageService
{
	// Signal for notification count
	public notificationCounts = signal(null as NotificationCounts | null);

	// Method to update count
	public updateNotificationCount(counts: NotificationCounts)
	{
		this.notificationCounts.set(counts);
	}

	// Signal for repeat count
	public repeatCount = signal(0);

	// Method to update repeat count
	public updateRepeatCount(count: number)
	{
		this.repeatCount.set(count);
	}

}
